export const FASTAG_REKYV_SAMPLE_FILENAME = 'bulk_sample.zip';
export const FASTAG_VRN_DETAIL_SAMPLE_FILENAME = 'vrn_detail_sample.csv';
export const FASTAG_CHASSIS_TO_VRN_SAMPLE_FILENAME = 'chassis_to_vrn_sample.csv';

const SAMPLE_ZIP_URL = `${process.env.PUBLIC_URL || ''}/samples/fastag-rekyv/bulk_sample.zip`;
const SAMPLE_CSV_URL = `${process.env.PUBLIC_URL || ''}/samples/fastag-rekyv/vrn_detail_sample.csv`;
const SAMPLE_CHASSIS_TO_VRN_CSV_URL = `${process.env.PUBLIC_URL || ''}/samples/fastag-rekyv/chassis_to_vrn_sample.csv`;

async function downloadSampleFile(url, filename) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Sample file is not available. Please try again later.');
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}

export async function downloadFastagReKyvSampleZip() {
  await downloadSampleFile(SAMPLE_ZIP_URL, FASTAG_REKYV_SAMPLE_FILENAME);
}

export async function downloadFastagVrnDetailSampleCsv() {
  await downloadSampleFile(SAMPLE_CSV_URL, FASTAG_VRN_DETAIL_SAMPLE_FILENAME);
}

export async function downloadFastagChassisToVrnSampleCsv() {
  await downloadSampleFile(SAMPLE_CHASSIS_TO_VRN_CSV_URL, FASTAG_CHASSIS_TO_VRN_SAMPLE_FILENAME);
}
